import { SpeciesEnum } from "requests";
import { ROOTS } from "./constants";

export const getRoots = (species: SpeciesEnum | null, toothNumber: number) => {
  if (!species) {
    return [];
  }

  return (
    ROOTS.find(({ teethNumbers }) =>
      teethNumbers[species]?.includes(toothNumber)
    )?.rootsNames || []
  );
};
